interface LogoProps {
  className?: string
}

export function Logo({ className = 'h-8 w-8' }: LogoProps) {
  return (
    <svg className={className} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Outer circle - represents the boundary of the system */}
      <circle cx="50" cy="50" r="45" stroke="currentColor" strokeWidth="3" className="text-primary-600" />
      {/* Inner dot - represents N=1, the single internal reference point */}
      <circle cx="50" cy="50" r="8" fill="currentColor" className="text-primary-600" />
    </svg>
  )
}
